/**
 * 路由配置
 * @description 所有路由都在这里集中管理
 */
const routes: any[] = [
  // 登录页
  {
    path: '/',
    redirect: '/creative',
  },
  // 404
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '404页',
      show: false,
    },
  },
  // 微信扫码登录回调（iframe self_redirect 时在此页收 code 并 postMessage 给父窗口；直接打开则换 token 后跳转）
  {
    path: '/wechat/callback',
    name: 'WechatCallback',
    component: () => import('@/views/wechat/callback.vue'),
    meta: {
      title: '微信登录',
      show: false,
    },
  },
  // 余额查询（独立页，不进菜单，直接通过 /credits 访问）
  {
    path: '/credits',
    name: 'CreditsQuery',
    component: () => import('@/views/credits/index.vue'),
    meta: {
      title: '余额查询',
      show: false,
    },
  },
  // 用户协议 / 隐私政策：在 layout 框架下展示（URL 保持不变）
  {
    path: '/agreement',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '用户协议',
      show: false,
    },
    children: [
      {
        path: '',
        name: 'UserAgreement',
        component: () => import('@/views/legal/userAgreement.vue'),
        meta: {
          title: '用户协议',
          show: false,
        },
      },
    ],
  },
  {
    path: '/privacyPolicy',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '隐私政策',
      show: false,
    },
    children: [
      {
        path: '',
        name: 'PrivacyPolicy',
        component: () => import('@/views/legal/privacyPolicy.vue'),
        meta: {
          title: '隐私政策',
          show: false,
        },
      },
    ],
  },
  {
    path: '/aboutUs',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '关于我们',
      show: false,
    },
    children: [
      {
        path: '',
        name: 'AboutUs',
        component: () => import('@/views/legal/about.vue'),
        meta: {
          title: '关于我们',
          show: false,
        },
      },
    ],
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/layouts/layout.vue'),
    redirect: '/chat/completions',
    meta: {
      title: 'AI对话',
      show: true,
      icon: 'ri:chat-3-line',
    },
    children: [
      {
        path: 'completions',
        name: 'ChatCompletions',
        component: () => import('@/views/chat/index.vue'),
        meta: {
          title: '聊天',
          show: false,
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: '/creative',
    name: 'Creative',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '灵感发现',
      show: false,
      icon: 'ri:star-line',
    },
    children: [
      {
        path: '',
        name: 'CreativeIndex',
        component: () => import('@/views/creative/index.vue'),
        meta: {
          title: '灵感发现',
          show: false,
          keepAlive: true,
        },
      },
      {
        path: 'generating',
        name: 'Generating',
        component: () => import('@/views/creative/generating.vue'),
        meta: {
          title: '创意生成',
          show: false,
          // 生成任务与 WebSocket 已全局托管；页面本身不缓存，避免活动任务期间旧视图滞留。
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/inspiration',
    name: 'Inspiration',
    redirect: '/creative/generating',
    meta: {
      title: '创意生成',
      show: false,
      icon: 'ri:lightbulb-line',
    },
  },
  {
    path: '/canvas',
    name: 'Canvas',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '无限画布',
      show: false,
      icon: 'ri:artboard-line',
    },
    children: [
      {
        path: '',
        name: 'CanvasIndex',
        component: () => import('@/views/canvas/index.vue'),
        meta: {
          title: '无限画布',
          show: false,
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: '/canvas/:id',
    name: 'CanvasDetail',
    component: () => import('@/views/canvas/detail.vue'),
    meta: {
      title: '无限画布',
      show: false,
    },
  },
  {
    path: '/hot',
    name: 'Hot',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '热门模型',
      show: false,
      icon: 'ri:fire-line',
    },
    children: [
      {
        path: '',
        name: 'HotIndex',
        component: () => import('@/views/hotModel/index.vue'),
        meta: {
          title: '热门模型',
          show: false,
          keepAlive: true,
        },
      },
      {
        path: ':id',
        name: 'HotMakeSame',
        component: () => import('@/views/hotModel/makeSame.vue'),
        meta: {
          title: '做同款',
          show: false,
        },
      },
    ],
  },
  {
    path: '/modelSquare',
    name: 'ModelSquare',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '模型广场',
      show: false,
      icon: 'ri:apps-2-line',
    },
    children: [
      {
        path: '',
        name: 'ModelSquareIndex',
        component: () => import('@/views/modelSquare/index.vue'),
        meta: {
          title: '模型广场',
          show: false,
        },
      },
      {
        path: 'usage',
        name: 'ModelSquareUsage',
        component: () => import('@/views/modelSquare/usage.vue'),
        meta: {
          title: '用量统计',
          show: false,
        },
      },
    ],
  },
  {
    path: '/more',
    name: 'More',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '更多工具',
      show: false,
      icon: 'ri:apps-line',
    },
    children: [
      {
        path: '',
        name: 'MoreIndex',
        component: () => import('@/views/more/index.vue'),
        meta: {
          title: '更多工具',
          show: false,
          keepAlive: true,
        },
      },
      {
        path: 'detail',
        name: 'MoreDetail',
        component: () => import('@/views/more/detail.vue'),
        meta: {
          title: '工具使用',
          show: false,
        },
      },
    ],
  },
  {
    path: '/assets',
    name: 'Assets',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '资产',
      show: false,
      icon: 'assets',
    },
    children: [
      {
        path: '',
        name: 'AssetsIndex',
        component: () => import('@/views/assets/index.vue'),
        meta: {
          title: '资产',
          show: false,
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: '/personCenter',
    name: 'PersonCenter',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '个人中心',
      show: false,
      icon: 'ri:user-settings-line',
    },
    children: [
      {
        path: '',
        name: 'PersonCenterIndex',
        component: () => import('@/views/personCenter/index.vue'),
        meta: {
          title: '个人中心',
          show: false,
        },
      },
    ],
  },
  {
    path: '/user/:id',
    name: 'UserShare',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '分享主页',
      show: false,
    },
    children: [
      {
        path: '',
        name: 'UserShareIndex',
        component: () => import('@/views/share/index.vue'),
        meta: {
          title: '分享主页',
          show: false,
        },
      },
    ],
  },
  {
    path: '/settings',
    component: () => import('@/layouts/layout.vue'),
    meta: {
      title: '设置',
      show: false,
      icon: 'ri:user-settings-line',
    },
    children: [
      {
        path: 'usage',
        name: 'usageIndex',
        component: () => import('@/views/settings/usage.vue'),
        meta: {
          title: '模型使用',
          show: false,
        },
      },
      {
        path: 'credit',
        name: 'creditIndex',
        component: () => import('@/views/settings/credit.vue'),
        meta: {
          title: '积分明细',
          show: false,
        },
      },
      {
        path: 'bills',
        name: 'billsIndex',
        component: () => import('@/views/settings/bills.vue'),
        meta: {
          title: '账单信息',
          show: false,
        },
      },
      {
        path: 'invoice',
        name: 'invoiceIndex',
        component: () => import('@/views/settings/invoice.vue'),
        meta: {
          title: '发票管理',
          show: false,
        },
      },
      {
        path: 'invite',
        name: 'inviteIndex',
        component: () => import('@/views/settings/invite.vue'),
        meta: {
          title: '邀请有礼',
          show: false,
        },
      },
      {
        path: 'about',
        name: 'aboutIndex',
        component: () => import('@/views/settings/about.vue'),
        meta: {
          title: '关于我们',
          show: false,
        },
      },
      {
        path: 'safe',
        name: 'safeIndex',
        component: () => import('@/views/settings/safe.vue'),
        meta: {
          title: '账号安全',
          show: false,
        },
      },
    ],
  },
  // 管理后台（不进菜单，通过 /admin 直接访问）
  {
    path: '/admin',
    name: 'AdminConsole',
    component: () => import('@/views/admin/index.vue'),
    meta: {
      title: '管理后台',
      show: false,
    },
  },
]

export default routes
